export default __webpack_public_path__ + "static/orix_signature_logo-7ca7e477bdbe7583b3971d1f24c48bf5.jpg";